module.exports = __webpack_public_path__ + "img/pdf-icon.149647dc.png";